module.exports = __webpack_public_path__ + "img/bakery.ad5fabc5.jpeg";